import { useEffect, useRef, useState } from 'react';
import styles from './index.module.sass';
import classNames from 'classnames';
import arrowIcon from '@@/offer/images/arrow.svg';
import successIcon from '@@/offer/images/check.svg';

export const Dropdown = ({
  title,
  placeholder,
  options,
  onSelectOption,
  multipleSelect,
}: IArgs) => {
  const dropdonwRef: any = useRef(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    function handleClickOutside(event: Event) {
      if (dropdonwRef.current && !dropdonwRef.current.contains(event.target)) {
        setExpanded(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.root} ref={dropdonwRef}>
      <span className={styles.title}>{title}</span>
      <div className={styles.dropdown}>
        <div className={classNames(styles.visibleArea, expanded && styles.expanded)} onClick={() => setExpanded(!expanded)}>
          {placeholder}
          <img style={{ transform: expanded ? 'rotate(180deg)' : 'none' }} src={arrowIcon}/>
        </div>
        <ul className={classNames(styles.optionsArea, expanded && styles.active)}>
          {options.map((item, i) => (
            <li
              className={classNames(
                styles.dropdownOption,
                item.active && styles.activeOption,
              )}
              onClick={() => {
                onSelectOption(item);
                !multipleSelect && setExpanded(false);
              }}
            >
              {item.label}
              <img style={{ opacity: item.active ? 1 : 0 }} className={styles.checked} src={successIcon}/>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

type dropdownOption = {
  label: string;
  value: string;
  active: boolean;
};

interface IArgs {
  title: string;
  placeholder: string;
  options: dropdownOption[];
  onSelectOption: (option: dropdownOption) => void;
  multipleSelect: boolean;
}